module.exports = __webpack_public_path__ + "static/media/tocbg.25288dc7.jpg";